// Debug utility - controls error logging and display
// Set VITE_DEBUG_MODE=true in .env to enable debug mode
// In production (when NODE_ENV=production), debug mode is automatically disabled
// In development, debug mode is enabled by default

const isDebugMode = import.meta.env.VITE_DEBUG_MODE === 'true' || import.meta.env.DEV;

export { isDebugMode };
